import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
const api = () => axios.create({ baseURL: '/api', headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }});

export default function NotificationBell({ user }) {
 const [notifs, setNotifs] = useState([]);
 const [unread, setUnread] = useState(0);
 const [open, setOpen] = useState(false);
 const ref = useRef();
 const http = api();

 useEffect(() => {
 const fetch = async () => {
 try {
 const [n, u] = await Promise.all([http.get('/notifications'), http.get('/notifications/unread-count')]);
 setNotifs(n.data); setUnread(u.data.unread);
 } catch(e) { /* silent */ }
 };
 fetch();
 const interval = setInterval(fetch, 30000);
 return () => clearInterval(interval);
 }, []);

 useEffect(() => {
 const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
 document.addEventListener('mousedown', handler);
 return () => document.removeEventListener('mousedown', handler);
 }, []);

 const markRead = async (id) => {
 await http.put(`/notifications/${id}/read`);
 setNotifs(n => n.map(x => x.id===id?{...x,is_read:true}:x));
 setUnread(u => Math.max(0,u-1));
 };

 const markAllRead = async () => {
 await http.put('/notifications/read-all');
 setNotifs(n => n.map(x=>({...x,is_read:true})));
 setUnread(0);
 };

 return (
 <div className="relative" ref={ref}>
 <button onClick={() => setOpen(!open)} className="relative p-2 rounded-full hover:bg-neutral-100 transition" aria-label="Notifications">
 <svg className="w-5 h-5 text-neutral-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/></svg>
 {unread > 0 && <span className="absolute -top-0.5 -right-0.5 bg-rose-500 text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center">{unread > 99 ? '99+' : unread}</span>}
 </button>
 {open && (
 <div className="absolute right-0 top-12 w-80 sm:w-96 bg-white rounded-2xl shadow-xl border border-neutral-100 z-50 max-h-[70vh] overflow-hidden flex flex-col">
 <div className="p-4 border-b border-neutral-100 flex items-center justify-between">
 <span className="font-bold text-neutral-900">Notifications</span>
 {unread > 0 && <button onClick={markAllRead} className="text-xs text-brand-600 font-semibold hover:underline">Mark all read</button>}
 </div>
 <div className="overflow-y-auto max-h-[50vh]">
 {notifs.length === 0 ? (
 <div className="p-8 text-center text-neutral-400 text-sm">No notifications yet</div>
 ) : notifs.map(n => (
 <div key={n.id} onClick={() => { if(!n.is_read) markRead(n.id); }} className={`p-4 border-b border-neutral-50 cursor-pointer hover:bg-neutral-50 ${!n.is_read ? 'bg-brand-50/50' : ''}`}>
 <div className="flex items-start gap-3">
 <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm flex-shrink-0 ${
 n.type === 'application' ? 'bg-blue-100 text-blue-600' : n.type === 'hired' ? 'bg-brand-100 text-brand-600' : n.type === 'message' ? 'bg-purple-100 text-purple-600' : n.type === 'shift_complete' ? 'bg-emerald-100 text-emerald-600' : 'bg-neutral-100 text-neutral-500'
 }`}>
 {n.type === 'application' ? (
 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
 ) : n.type === 'hired' ? (
 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
 ) : n.type === 'message' ? (
 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/></svg>
 ) : n.type === 'shift_complete' ? (
 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"/></svg>
 ) : (
 <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/></svg>
 )}
 </div>
 <div className="flex-1 min-w-0">
 <p className="font-semibold text-neutral-900 text-sm">{n.title}</p>
 <p className="text-xs text-neutral-500 mt-0.5 truncate">{n.message}</p>
 <p className="text-[10px] text-neutral-400 mt-1">{new Date(n.created_at).toLocaleString()}</p>
 </div>
 {!n.is_read && <div className="w-2 h-2 rounded-full bg-brand-500 mt-2 flex-shrink-0" />}
 </div>
 </div>
 ))}
 </div>
 </div>
 )}
 </div>
 );
}
